/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	"use strict";
	/*globals Tc */
	/*jshint smarttabs:true */
	/**
	 * @namespace Tc.Module
	 * @class ProductItemGroup
	 * @extends Tc.Module
	 */
	Tc.Module.ProductItemGroup = Tc.Module.extend({

		on: function (callback) {
			var mod = this;
			mod.titleBox = $('.title-box', mod.$ctx);
			mod.contentBox = $('.content-box', mod.$ctx);

			mod.titleBox.on('click', function(){
				mod.contentBox.slideToggle(200, function(){
					mod.$ctx.toggleClass('active');
				});
			});
			callback();
		},

		after: function () {
			var mod = this;
			mod.$ctx.find(":input[data-price],:input[data-onetime-charge],:input[data-type=item]").on("change", $.proxy(mod.updatePrice, mod));
			mod.updatePrice();
		},

		updatePrice: function() {
			var mod = this,
				total = 0;
			mod.$ctx.find(':input[data-price],.modBaseBundleOption :input[data-hascost]').each(function () {
				var $this = $(this),
					amount = ($this.filter('[data-hascost]').length && $this.data('hascost') != "") ? $this.data('hascost') : $this.val(),
					price = amount * $this.data('price'),
					isCheckboxOrRadio = $this.is(':checkbox') || $this.is(':radio');

				if (amount > 0) {
					if (isNaN(price)) {
						return;
					}
					if (isCheckboxOrRadio && !$this.is(':checked')) {
						return;
					}
					total += price;
				}
			});
			if (total == 0) {
				mod.$ctx.find('.title-box .price-monthly').addClass('empty').html('&nbsp;');
			} else {
				mod.$ctx.find('.title-box .price-monthly').removeClass('empty').text(parseFloat(Math.round(total * 100) / 100).toFixed(2));
			}

			total = 0;
			mod.$ctx.find(':input[data-onetime-charge]').each(function () {
				var $this = $(this),
					amount = $this.data('hascost'),
					price = amount * $this.data('onetime-charge'),
					isCheckboxOrRadio = $this.is(':checkbox') || $this.is(':radio');

				if (amount > 0) {
					if (isNaN(price)) {
						return;
					}
					if (isCheckboxOrRadio && !$this.is(':checked')) {
						return;
					}
					total += price;
				}
			});
			if (total == 0) {
				mod.$ctx.find('.title-box .price-once').addClass('empty').html('&nbsp;');
			} else {
				mod.$ctx.find('.title-box .price-once').removeClass('empty').text(parseFloat(Math.round(total * 100) / 100).toFixed(2));
			}
		}
	});
})(Tc.$);
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductItemGroup.js
// module id = 254
// module chunks = 0